module.exports = __webpack_public_path__ + "img/天府新区太平中学.69099da9.jpg";